module.exports = __webpack_public_path__ + "img/93.c2538402.jpg";